/* Progressive enhancement: answers and topic links work without JavaScript. */
(() => {
  const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  function initialize(scope = document) {
    scope.querySelectorAll('[data-st-faq]').forEach(faq => {
      if (faq.dataset.initialized) return;
      faq.dataset.initialized = 'true';
      const input = faq.querySelector('[data-faq-search]');
      const groups = [...faq.querySelectorAll('[data-faq-group]')];
      const rows = [...faq.querySelectorAll('[data-faq-question]')].map(element => ({ element, text: normalize(element.textContent), wasOpen: false }));
      let searching = false;
      function filter() {
        const query = normalize(input.value.trim());
        let count = 0;
        rows.forEach(row => {
          if (query && !searching) row.wasOpen = row.element.open;
          const match = !query || query.split(/\s+/).every(word => row.text.includes(word));
          row.element.hidden = !match;
          if (query) row.element.open = match;
          else if (searching) row.element.open = row.wasOpen;
          if (match) count++;
        });
        groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-faq-question]')].some(row => !row.hidden); });
        faq.querySelector('[data-faq-status]').hidden = count > 0;
        searching = Boolean(query);
      }
      input.addEventListener('input', filter);
      faq.querySelectorAll('[data-faq-topic]').forEach(link => link.addEventListener('click', () => { input.value = ''; filter(); }));
      faq.querySelector('[data-faq-search-wrap]').hidden = false;
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
